import { Context } from '@/models/order-history/status/context/context'
import { paymentTypeIsExternalPayment } from '@/models/order-history/status/context/payment-type'
import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { ForDefaultPaymentMethod } from '@spa/components/organisms/mypage/order/model/order-status-view/commands/for-default-payment-method'
import { CreateOrderStatusViewModelCommand } from '@spa/components/organisms/mypage/order/model/order-status-view/create-command'
import { orderStatusViewKinds } from '@spa/components/organisms/mypage/order/model/order-status-view/kind'

interface ApplicableContext extends Context {
  paymentType: 'carrier' | 'webmoney' | 'creditcard3d'
}

/**
 * @internal モジュールの外部からはcreateOrderStatusViewModelを利用すること
 */
export class ForExternalPayment extends CreateOrderStatusViewModelCommand<ApplicableContext> {
  shouldApply(context: Pick<Context, 'paymentType'>): context is ApplicableContext {
    return paymentTypeIsExternalPayment(context.paymentType)
  }
  createViewModel(
    context: ApplicableContext
  ): OrderStatusViewModel {
    // デフォルトにフォールバックする
    const fallback = (c: Context) => new ForDefaultPaymentMethod().execute(c)

    /**
     * 外部決済の場合はEngineに注文データを作成してから外部ページに遷移するため、
     * 外部ページでブラウザバックするなど処理が完了されなかった場合にpayment-requestedな注文データが残る。
     * この場合、再度決済ページへの案内などは行わず、注文はエラー扱いとする。
     */
    if (context.engineStatus === 'payment-requested') {
      return orderStatusViewKinds.paymentNotAccepted
    }

    /**
     * 再決済の期限が切れた場合はNP後払いと同様に期限切れの表示とする
     */
    if (context.engineStatus === 'payment-fatal-error') {
      return orderStatusViewKinds.paymentExpired
    }

    return fallback(context)
  }
}
